<div class="bank-account-card">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex gap-1 align-items-center">
      <app-radio-button-input
        formControlName="bankAccountId"
        [value]="null"
        [name]="'bankAccountId'"
        [controlId]="'bankAccountId'" />
      <label class="bank-account-name" for="bankAccountId" i18n>Written Cheque</label>
    </div>
  </div>
</div>
